import React from 'react';
import { Alert } from '../../data/types';
import { AlertTriangle, TrendingDown, Activity } from 'lucide-react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
interface AlertCardProps {
  alert: Alert;
}
export function AlertCard({
  alert
}: AlertCardProps) {
  const getIcon = () => {
    switch (alert.type) {
      case 'concern_spike':
        return Activity;
      case 'kpi_drop':
        return TrendingDown;
      default:
        return AlertTriangle;
    }
  };
  const Icon = getIcon();
  const severityStyles = {
    critical: 'border-danger/50 bg-danger/5 text-danger',
    warning: 'border-warning/50 bg-warning/5 text-warning',
    info: 'border-info/50 bg-info/5 text-info'
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className={clsx('flex items-start p-4 rounded-lg border mb-3 backdrop-blur-sm', severityStyles[alert.severity])} data-id="element-76">
      <div className={clsx('p-2 rounded-full mr-3 shrink-0', alert.severity === 'critical' ? 'bg-danger/20 animate-pulse' : 'bg-white/5')} data-id="element-77">
        <Icon className="w-5 h-5" data-id="element-78" />
      </div>

      <div className="flex-1" data-id="element-79">
        <div className="flex justify-between items-start" data-id="element-80">
          <h4 className="font-semibold text-sm uppercase tracking-wider opacity-90 mb-1" data-id="element-81">
            {alert.type.replace('_', ' ')}
          </h4>
          <span className="text-xs opacity-60" data-id="element-82">{alert.timestamp}</span>
        </div>
        <p className="text-sm opacity-90 mb-3" data-id="element-83">{alert.explanation}</p>
        <button className="text-xs font-medium underline hover:opacity-80 transition-opacity" data-id="element-84">
          Investigate Issue
        </button>
      </div>
    </motion.div>;
}